var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 10.8H10.8V5.2H5.2V10.8ZM8 15C7.03166 15 6.12166 14.8161 5.27 14.4484C4.41833 14.0807 3.6775 13.582 3.0475 12.9525C2.4175 12.323 1.91887 11.5821 1.5516 10.73C1.18433 9.87786 1.00047 8.96786 1 8C0.999534 7.03213 1.1834 6.12213 1.5516 5.27C1.9198 4.41787 2.41843 3.67703 3.0475 3.0475C3.67657 2.41797 4.4174 1.91933 5.27 1.5516C6.1226 1.18387 7.0326 1 8 1C8.9674 1 9.87739 1.18387 10.73 1.5516C11.5826 1.91933 12.3234 2.41797 12.9525 3.0475C13.5816 3.67703 14.0804 4.41787 14.4491 5.27C14.8178 6.12213 15.0014 7.03213 15 8C14.9986 8.96786 14.8147 9.87786 14.4484 10.73C14.0821 11.5821 13.5834 12.323 12.9525 12.9525C12.3216 13.582 11.5807 14.0809 10.73 14.4491C9.87926 14.8173 8.96926 15.0009 8 15ZM8 13.6C9.56333 13.6 10.8875 13.0575 11.9725 11.9725C13.0575 10.8875 13.6 9.56333 13.6 8C13.6 6.43667 13.0575 5.1125 11.9725 4.0275C10.8875 2.9425 9.56333 2.4 8 2.4C6.43666 2.4 5.1125 2.9425 4.0275 4.0275C2.9425 5.1125 2.4 6.43667 2.4 8C2.4 9.56333 2.9425 10.8875 4.0275 11.9725C5.1125 13.0575 6.43666 13.6 8 13.6Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopAudioIcon);
export default __webpack_public_path__ + "static/media/stop-audio-icon.7905f90438047469b3d5b10a91b80159.svg";
export { ForwardRef as ReactComponent };